/* batida-v7-home.js: the small interactions of the new batida.pl home page (Aleksandra's prototype, 27.09).
   Everything works without it: the page shows the first coffee, the Basic list, Monday's hours and no countdown.
   - coffee → dessert chooser (sections/batida-v7-coffee)
   - Basic / Premium + switch (sections/batida-v7-station)
   - "Zamów na jutro" countdown to the cut-off hour, Warsaw time (sections/batida-v7-hero)
   - today's opening hours, Warsaw time (sections/batida-v7-locations)
   - hero photo crossfade, blocks fading in on scroll (both off for people who asked for less motion) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Warsaw time as parts, whatever the visitor's own time zone is
  function warsawNow() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var days = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    return { day: days[o.weekday], sec: (+o.hour % 24) * 3600 + (+o.minute) * 60 + (+o.second) };
  }

  // coffee → dessert
  document.querySelectorAll('[data-v7-coffee]').forEach(function (root) {
    var card = root.querySelector('[data-cof-card]');
    if (!card) return;
    var img = card.querySelector('[data-cof-img]');
    // 6.10: the other coffees' photos used to start downloading only after the click; fetch them all once the page has loaded
    function warm() {
      root.querySelectorAll('.v7h-cof__opt[data-cof-i]').forEach(function (b) {
        var src = b.getAttribute('data-cof-i');
        if (!src) return;
        var w = new Image();
        w.sizes = img ? img.sizes : '';
        if (b.getAttribute('data-cof-s')) w.srcset = b.getAttribute('data-cof-s');
        w.src = src;
      });
    }
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.v7h-cof__opt');
      if (!b || b.getAttribute('aria-pressed') === 'true') return;
      root.querySelectorAll('.v7h-cof__opt').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      card.classList.add('is-swap');
      setTimeout(function () {
        var src = b.getAttribute('data-cof-i');
        if (img) { if (src) { var ss = b.getAttribute('data-cof-s'); if (ss) img.srcset = ss; else img.removeAttribute('srcset'); img.src = src; img.alt = b.getAttribute('data-cof-a') || ''; img.hidden = false; } else { img.hidden = true; } }
        card.querySelector('[data-cof-k]').textContent = b.getAttribute('data-cof-k');
        card.querySelector('[data-cof-n]').textContent = b.getAttribute('data-cof-n');
        card.querySelector('[data-cof-d]').textContent = b.getAttribute('data-cof-d');
        var pr = card.querySelector('[data-cof-p]');
        if (pr) { pr.textContent = b.getAttribute('data-cof-p') || ''; pr.hidden = !pr.textContent; }
        var u = card.querySelector('[data-cof-u]');
        if (u && b.getAttribute('data-cof-u')) u.setAttribute('href', b.getAttribute('data-cof-u'));
        card.classList.remove('is-swap');
      }, reduce ? 0 : 320);
    });
  });

  // Basic / Premium +
  document.querySelectorAll('[data-v7-pk]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pk]');
      if (!b) return;
      var k = b.getAttribute('data-pk');
      root.querySelectorAll('[data-pk]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      root.querySelectorAll('[data-pk-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pk-pane') !== k; });
      // F23: "Zapytaj o stację" carries the chosen package into the catering form (?pakiet=, assets/batida-v7-catering-page.js)
      root.querySelectorAll('[data-v7-pk-cta]').forEach(function (a) {
        try { var u = new URL(a.getAttribute('href'), location.href); u.searchParams.set('pakiet', b.textContent.trim()); a.setAttribute('href', u.origin === location.origin ? u.pathname + u.search + u.hash : u.href); } catch (err) { /* keep the link */ }
      });
    });
  });

  // countdown to today's cut-off (hidden after it)
  var cds = document.querySelectorAll('[data-v7-countdown]');
  if (cds.length) {
    var tick = function () {
      var n = warsawNow();
      cds.forEach(function (el) {
        var m = (el.getAttribute('data-cutoff') || '').match(/(\d{1,2})[:.](\d{2})/);
        if (!m) { el.hidden = true; return; }
        var left = (+m[1]) * 3600 + (+m[2]) * 60 - n.sec;
        // Sundays are closed in the cart calendar, so on Saturday there is no "for tomorrow"
        if (left <= 0 || n.day === 5) { el.hidden = true; return; }
        var h = Math.floor(left / 3600), mi = Math.floor(left % 3600 / 60), s = left % 60;
        el.querySelector('[data-v7-countdown-time]').textContent = (h < 10 ? '0' : '') + h + ':' + (mi < 10 ? '0' : '') + mi + ':' + (s < 10 ? '0' : '') + s;
        el.hidden = false;
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  // today's hours
  var day = warsawNow().day;
  document.querySelectorAll('[data-v7-hours]').forEach(function (el) {
    try {
      var hrs = JSON.parse(el.getAttribute('data-v7-hours'));
      var t = (hrs[day] || '').replace(/\s*[-–—]\s*/g, '-'); /* ranges with a short hyphen, no spaces: 9:00-20:00 */
      el.textContent = t ? (el.getAttribute('data-today') || 'dziś') + ' ' + t : (el.getAttribute('data-closed') || '');
    } catch (err) { /* keep Monday's hours */ }
  });


  // hero: Halloween slide in front of the normal hero (5.10): autoplay 9 s (6.10), dots, swipe, pause on hover/focus,
  // stops for good after the visitor's first touch / click / swipe on the slider or its dots (6.10, Aleksandra),
  // countdown, and the slide leaves by itself after its last day (the server also stops rendering it)
  (function () {
    var box = document.querySelector('[data-v7-slides]');
    if (!box) return;
    // Aleksandra 5.10: on phones the floating "Nagrody" button covered "Zobacz kolekcję" - it steps aside while the slider is on
    // screen (html.v7-hero-inview, CSS in batida-v7-home.css), like on product pages; it comes back once you scroll past
    try {
      new IntersectionObserver(function (es) { document.documentElement.classList.toggle('v7-hero-inview', es[0].isIntersecting); })
        .observe(box);
    } catch (e) {}
    // slide 1 (Halloween) is rendered first and active by the server, slide 2 = the main hero: nothing to swap here
    var slides = [].slice.call(box.querySelectorAll('[data-v7-slide]'));
    var dots = [].slice.call(document.querySelectorAll('[data-v7-dot]'));
    var until = parseInt(box.getAttribute('data-until'), 10) || 0;
    var i = 0, timer = null, x0 = null, gone = false, touched = false;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    // 8.10 (Pat, QA sweep): autoplay arms only after the first scroll / pointer move / key / touch of the visitor. An idle visitor
    // never sees slide 2 swap in 9 s later - Chrome counted that as a new LCP (desktop LCP ~9.5 s in Lighthouse and for real idle visitors).
    var armed = false;
    function play() { stop(); if (armed && !reduce && !gone && !touched) timer = setInterval(function () { go(i + 1); }, 9000); }
    // 6.10 (Aleksandra, point 3): the first touch / click / swipe on the slider or the dots = the visitor takes over, autoplay never restarts
    function halt() { touched = true; stop(); }
    function expire() {
      gone = true; stop();
      var main = slides[slides.length - 1];
      slides.forEach(function (s) { if (s !== main) s.remove(); });
      main.classList.add('is-on'); main.removeAttribute('aria-hidden');
      dots.forEach(function (d) { d.parentNode && d.parentNode.removeChild(d); });
      box.classList.remove('is-js');
    }
    // v2 counter: whole days from today (Europe/Warsaw calendar date) to the last day, plural forms per language
    function days2() {
      var c = box.querySelector('[data-v7-hal2-cd]'); if (!c) return;
      try {
        var t = c.getAttribute('data-until-date').split('-');
        var w = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()).split('-');
        var n = Math.round((Date.UTC(+t[0], t[1] - 1, +t[2]) - Date.UTC(+w[0], w[1] - 1, +w[2])) / 864e5);
        var b = c.querySelector('b'), l = c.querySelector('span'); if (!b || !l) return;
        if (n <= 0) { b.textContent = c.getAttribute('data-zero-b'); l.textContent = c.getAttribute('data-zero-l'); return; }
        var form = 'other';
        try { form = new Intl.PluralRules(document.documentElement.lang || 'pl').select(n); } catch (e) { }
        var txt = c.getAttribute('data-' + form) || c.getAttribute('data-other') || '';
        b.textContent = txt.replace(/\d+/, n);   // the server wrote today's number into the text; swap it for the browser's
        l.textContent = c.getAttribute('data-label');
      } catch (e) { /* keep the server's number */ }
    }
    function days() {
      days2();
    }
    if (until && Date.now() / 1000 > until) { expire(); return; }
    days();
    box.classList.add('is-js');
    go(0);
    dots.forEach(function (d, k) { d.addEventListener('click', function () { halt(); go(k); }); });
    box.addEventListener('pointerdown', halt, { passive: true });
    box.addEventListener('touchstart', halt, { passive: true });
    box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', play);
    box.addEventListener('focusin', stop); box.addEventListener('focusout', play);
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); halt(); }
    }, { passive: true });
    function arm() {
      if (armed) return; armed = true;
      ['scroll', 'pointermove', 'pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (ev) { window.removeEventListener(ev, arm); });
      play();
    }
    ['scroll', 'pointermove', 'pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (ev) { window.addEventListener(ev, arm, { passive: true }); });
  })();

  if (reduce) return;

  // hero: slow crossfade to the second photo
  document.querySelectorAll('.v7h-hero__alt').forEach(function (alt) {
    setInterval(function () { alt.classList.toggle('is-on'); }, 4200);
  });

  // blocks fade in as they come into view (the hero is already there)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.v7h:not(.v7h-hero):not(.v7h-marq)').forEach(function (s) {
      if (s.getBoundingClientRect().top < window.innerHeight) return;
      s.classList.add('v7h-rv');
      io.observe(s);
    });
  }
})();
